import React, { useContext } from 'react'
import { NotificationInline, NotificationManagerContext, Text, View } from 'oio-react'
import { CheckmarkCircledIcon } from 'assets/icons'
import { settingsPeopleUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'

const privacyOptions = [{
   name: 'Open',
   value: 'open',
   description: 'Anyone can see and join this Site\'s community'
}, {
   name: 'Private',
   value: 'exclusive',
   description: 'Anyone can see this Site\'s community, but they must be invited to become of Member of it'
}, {
   name: 'Secret',
   value: 'secret',
   description: 'All users must log in to see any part of this Site\'s community. Only people that are invited can become a Member.'
}]

const SettingsPeoplePrivacy = () => {
   const { organization } = useOrganization()
   const { updateOrganization, mutating } = useUpdateOrganization()
   const { showNotification } = useContext(NotificationManagerContext)

   const handleSelectPrivacyOption = async (value) => {
      try {
         await updateOrganization({ privacy: value })
         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         showNotification({
            message: err.message || 'An error occurred while saving changes',
            title: 'Error',
            type: 'error'
         })
      }
   }

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="People, Privacy & Roles"
            returnLinkTo={settingsPeopleUrl}
         />
         <View
            display="flex"
            justifyContent="center">
            <View
               width="100%"
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  marginBottom="40px"
                  display="flex">
                  <View paddingRight="60px[b-f]">
                     <ProtoHeadingBlock
                        title="Site Privacy"
                        description="Every community has different needs. Select the privacy option that works best for yours. Manage who can see, join and participate in your Community."
                        metatext={`This Community is currently set to: ${privacyOptions.find(o => o.value === organization.privacy).name}`}
                     />
                  </View>
               </View>
               {mutating && (
                  <NotificationInline
                     borderRadius="6px"
                     type="loading"
                     title="Updating..."
                     message="Update in progress"
                     paddingHorizontal="12px"
                     paddingVertical="12px"
                     textSize="1.5"
                  />
               )}
               <View
                  width="100%"
                  borderRadius="6px"
                  marginBottom="12px"
                  backgroundColor="#fff">
                  {privacyOptions.map((option, index) => (
                     <View
                        key={option.name}
                        onClick={() => handleSelectPrivacyOption(option.value)}
                        display="flex"
                        borderBottom={index !== privacyOptions.length - 1 && '1px solid #eee'}
                        padding="20px"
                        style={{ cursor: 'pointer' }}>
                        <View
                           padding="6px 0px"
                           marginRight="20px">
                           {option.value === organization.privacy && (
                              <CheckmarkCircledIcon width="20px" height="20px" color="#48c163" />
                           )}
                           {option.value !== organization.privacy && (
                              <View
                                 width="20px"
                                 height="20px"
                                 border="2px solid #ccc"
                                 borderRadius="50%"
                              />
                           )}
                        </View>
                        <View maxWidth="400px">
                           <Text size="2" weight="medium">
                              {option.name}
                           </Text>
                           <Text size="1.5" color="#555">
                              {option.description}
                           </Text>
                        </View>
                     </View>
                  ))}
               </View>
            </View>
         </View>
      </View>
   )
}

export default SettingsPeoplePrivacy
